// client/src/coms/views/chatview_parts/useChatEmojiPopoverClose.js
import { useEffect } from 'react';

export default function useChatEmojiPopoverClose({
  showEmojiPicker,
  setShowEmojiPicker,
  emojiButtonRef,
  emojiPopoverRef,
}) {
  useEffect(() => {
    function onPointerDown(e) {
      if (!showEmojiPicker) return;
      const t = e.target;
      const inButton = emojiButtonRef.current && emojiButtonRef.current.contains(t);
      const inPopover = emojiPopoverRef.current && emojiPopoverRef.current.contains(t);
      if (!inButton && !inPopover) {
        setShowEmojiPicker(false);
      }
    }

    function onKey(e) {
      if (e.key === 'Escape') {
        setShowEmojiPicker(false);
      }
    }

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('touchstart', onPointerDown, { passive: true });
    document.addEventListener('keydown', onKey);

    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('touchstart', onPointerDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [showEmojiPicker, setShowEmojiPicker, emojiButtonRef, emojiPopoverRef]);
}